import { isMetaPixelAllowedHost } from '~/utils/meta/identifiers';

export type FbqFn = ((...args: unknown[]) => void) & {
  queue?: unknown[];
  loaded?: boolean;
  version?: string;
  push?: FbqFn;
  callMethod?: (...args: unknown[]) => void;
};

declare global {
  // biome-ignore lint/style/useConsistentTypeDefinitions: interface required for declaration merging
  interface Window {
    fbq?: FbqFn;
    _fbq?: FbqFn;
  }
}

export const isMetaPixelEnabled = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  if (!process.env.NEXT_PUBLIC_META_PIXEL_ID) {
    return false;
  }

  return isMetaPixelAllowedHost(window.location.hostname);
};
